import {
  templateHireflixGetJobsListingRoute,
  templateJobPositionsKey,
} from '@features/enterprise/api/constants';
import { errorMessage } from '@features/profile';
import axiosInstance from '@server/axiosInstance';
import { Dispatch, SetStateAction } from 'react';
import { useQuery } from 'react-query';

interface UseGetHireflixTemplateJobPositionsParams {
  templateId?: string | number;
  setErrorText?: Dispatch<SetStateAction<string>>;
}

export const useGetHireflixTemplateJobPositions = ({
  templateId,
  setErrorText = () => {},
}: UseGetHireflixTemplateJobPositionsParams = {}) => {
  const {
    data: jobPositionsData,
    isLoading: isLoadingJobPositions,
    isError: isErrorJobPositions,
    isFetched: isFetchedJobPositions,
  } = useQuery({
    queryKey: [templateJobPositionsKey, templateId],
    queryFn: () =>
      axiosInstance
        .get(templateHireflixGetJobsListingRoute, {
          params: {
            template_id: templateId,
          },
        })
        .then((res) => res.data),
    onSuccess: (data) => {
      if (data.status !== 200) {
        setErrorText(data.message);
      } else {
        setErrorText('');
      }
    },
    onError: () => setErrorText(errorMessage),
    refetchOnWindowFocus: false,
  });

  return {
    jobPositionsData,
    isLoadingJobPositions,
    isErrorJobPositions,
    isFetchedJobPositions,
  };
};
